import { render, staticRenderFns } from "./addDollarRate.vue?vue&type=template&id=0b99c322&scoped=true&"
import script from "./addDollarRate.vue?vue&type=script&lang=js&"
export * from "./addDollarRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b99c322",
  null
  
)

export default component.exports